import React, { useRef, useState } from "react";
import styled, { css } from "styled-components";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.min.css";
import "swiper/swiper.min.css";

import firstInfo1 from "assets/image/firstInfo1.png";
import firstInfo2 from "assets/image/firstInfo2.png";
import firstInfo3 from "assets/image/firstInfo3.png";
import firstInfo4 from "assets/image/firstInfo4.png";
import { theme } from "styles";
import Text from "components/ui/Text";

const TextArray = [
  {
    text1: "오늘 하루 센터는?",
    text2: "센터의 상황을 한눈에",
    text3: "오늘의 스케줄과 매출, 문의사항 등",
    text4: "센터의 상황을 한번에!",
    image: firstInfo1,
  },
  {
    text1: "강사 · 스케줄별",
    text2: "수업현황을 편하게",
    text3: "강사, 스케줄별은 물론 수업현황을",
    text4: "실시간으로 확인할 수 있어요!",
    image: firstInfo2,
  },
  {
    text1: "기간 · 종류별 매출",
    text2: "흐름을 한눈에",
    text3: "일간, 주간, 월간 매출 확인은 물론",
    text4: "흐름까지 한눈에 확인할 수 있어요!",
    image: firstInfo3,
  },
  {
    text1: "실시간 현황보고",
    text2: "내 손안에 작은 비서",
    text3: "언제 어디서나 간편하게 센터 현황을",
    text4: "실시간으로 확인할 수 있어요!",
    image: firstInfo4,
  },
];

const DotComponent = ({ step }) => {
  return (
    <Dot>
      {[0, 1, 2, 3].map((v) => {
        if (step === v) {
          return <div key={v} className="dot active"></div>;
        } else {
          return <div key={v} className="dot"></div>;
        }
      })}
    </Dot>
  );
};
const FirstInInfo = ({ onClose }) => {
  const nextRef = useRef();
  const [step, setStep] = useState(0);

  const handleSwiper = (e) => {
    nextRef.current = () => e.slideNext();
  };
  const handleSlide = (e) => {
    setStep(e.activeIndex);
  };
  const handleClickDone = () => {
    onClose(false);
    window.localStorage.setItem("onBoarding", "Y");
  };

  return (
    <Wrapper>
      <Swiper
        spaceBetween={0}
        slidesPerView={1}
        onSlideChange={handleSlide}
        onSwiper={handleSwiper}
      >
        {TextArray.map((v) => (
          <SwiperSlide key={v.text1}>
            <InfoBox>
              <TopBox>
                <img src={v.image} alt="" />
              </TopBox>
              <BottomBox>
                <BottomTextTop>
                  <Text
                    display="block"
                    color="primary50"
                    fontSize="28px"
                    fontWeight="700"
                    lineHeight="38px"
                  >
                    {v.text1}
                  </Text>
                  <Text
                    display="block"
                    color="bluegray100"
                    fontSize="28px"
                    fontWeight="700"
                    lineHeight="38px"
                  >
                    {v.text2}
                  </Text>
                  <Text
                    display="block"
                    color="bluegray40"
                    fontSize="16px"
                    fontWeight="500"
                    lineHeight="26px"
                    css={css`
                      margin-top: 16px;
                      margin-bottom: 32px;
                    `}
                  >
                    {v.text3}
                    <br />
                    {v.text4}
                  </Text>
                </BottomTextTop>
              </BottomBox>
            </InfoBox>
          </SwiperSlide>
        ))}
      </Swiper>
      <Footer>
        <DotComponent step={step} />
        <FooterBtm>
          <div onClick={handleClickDone}>
            <Text
              color="bluegray40"
              fontSize="18px"
              fontWeight="500"
              lineHeight="21px"
            >
              건너뛰기
            </Text>
          </div>
          <div onClick={step === 3 ? handleClickDone : () => nextRef.current()}>
            <Text
              color="primary50"
              fontSize="18px"
              fontWeight="600"
              lineHeight="21px"
            >
              {step === 3 ? "시작하기" : "다음"}
            </Text>
          </div>
        </FooterBtm>
      </Footer>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  height: 100vh;
  background: #0f2859;
  color: white;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  .swiper-container {
    width: 100%;
    height: 100%;
  }
  .swiper-slide {
    height: 100%;
  }
`;

const InfoBox = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const TopBox = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  margin-left: 43px;
  height: 250px;
  img {
    height: 90%;
  }
`;

const BottomBox = styled.div`
  height: 212px;
  display: flex;
  flex-direction: column;
  background: #fff;
`;
const BottomTextTop = styled.div`
  flex: 1;
  margin-top: 36px;
  text-align: center;
`;

const Footer = styled.div`
  background: #fff;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;
const FooterBtm = styled.div`
  display: flex;
  justify-content: space-between;
  height: 69px;
  padding: 24px;
`;

const Dot = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  .dot {
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background-color: #eaeaff;
    margin-right: 6px;
    transition: width 0.1s ease;
  }
  .dot.active {
    width: 19px;
    border-radius: 5px;
    background: ${theme.colors["primary50"]};
  }
`;

export default FirstInInfo;
